<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <a v-if="item.href" :href="item.href" target="_blank" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </a>
                <router-link v-else :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div :class="className + '__link gnb__link--toggle d-xl-none'">
                    <h2>{{ item.title }}</h2>
                </div>
                <a v-if="item.href" :href="item.href" target="_blank" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </a>
                <router-link v-else :to="item.path" :class="className + '__link d-none d-xl-flex'">
                    <h2>{{ item.title }}</h2>
                </router-link>

                <div :class="className + '__sub'">
                    <v-row no-gutters justify="center" class="no-wrap">
                        <v-col v-for="child in item.children" cols="12" xl="2" :key="child.title">
                            <div :class="className + '__sub-inner'">
                                <a v-if="child.href" :href="child.href" target="_blank" :class="className + '-sub__link'">
                                    <h2>{{ child.title }}</h2>
                                </a>
                                <router-link v-else :to="child.path" :class="className + '-sub__link'">
                                    <h2>{{ child.title }}</h2>
                                </router-link>

                                <v-row no-gutters align="center">
                                    <v-col cols="12" v-if="child?.children?.length">
                                        <ul :class="className + '__sub2'">
                                            <template v-for="grandChild in child.children">
                                                <li v-if="!grandChild.children" :key="grandChild.title">
                                                    <a v-if="grandChild.href" :href="grandChild.href" target="_blank" :class="className + '-sub2__link'">{{ grandChild.title }}</a>
                                                    <router-link v-else :to="grandChild.path" :class="className + '-sub2__link'">{{ grandChild.title }}</router-link>
                                                </li>
                                            </template>
                                        </ul>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </li>
        </template>
    </ul>
    <!-- <ul v-else-if="className == 'slide-gnb'" :class="className">
        <template v-for="item in gnbs">
            <li :class="className + '__li'" :key="item.title">
                <router-link :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>
        </template>
    </ul> -->
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "About Us",
                    path: "/en/about#about",
                    children: [
                        {
                            title: "Vision & Mission",
                            path: "/en/about#about-vision",
                        },
                        {
                            title: "Greetings",
                            path: "/en/about#about-greeting",
                        },
                        {
                            title: "History",
                            path: "/en/about#about-history",
                        },
                        {
                            title: "CI/BI",
                            path: "/en/about#about-cibi",
                        },
                        {
                            title: "Certificates",
                            path: "/en/about#about-technology",
                            children: [
                                {
                                    title: "Patents",
                                    path: "/en/about#about-patent",
                                },
                                {
                                    title: "Certificates",
                                    path: "/en/about#about-certification",
                                },
                                {
                                    title: "Trademark/Design",
                                    path: "/en/about#about-trademark",
                                },
                                {
                                    title: "Awards",
                                    path: "/en/about#about-award",
                                },
                            ],
                        },
                    ],
                },
                {
                    title: "Business",
                    path: "/en/business#business",
                    children: [
                        {
                            title: "Business Roadmap",
                            path: "/en/business#business-roadmap",
                        },
                        {
                            title: "Smart Farm Solution",
                            path: "/en/business#business-solution",
                        },
                        {
                            title: "Smart Farm Facility",
                            path: "/en/business#business-facility",
                        },
                        {
                            title: "Cultivation",
                            path: "/en/business#business-crop",
                        },
                        {
                            title: "Distribution Service",
                            path: "/en/business#business-distribution",
                        },
                    ],
                },
                {
                    title: "Competitiveness",
                    path: "/en/technology#technology",
                    children: [
                        {
                            title: "Key Technology",
                            path: "/en/technology#technology-core",
                        },
                        {
                            title: "Experts",
                            path: "/en/technology#technology-expert",
                        },
                        {
                            title: "R&D Center & Cultivation Facility",
                            path: "/en/technology#technology-facility",
                        },
                    ],
                },
                {
                    title: "Solutions",
                    path: "/en/solution/smartfarm/rmfarm#rmfarm",
                    children: [
                        {
                            title: "Farmire Smart Farm",
                            path: "/en/solution/smartfarm/rmfarm#rmfarm",
                            children: [
                                {
                                    title: "Advance Level",
                                    path: "/en/solution/smartfarm/rmfarm#rmfarm",
                                },
                                {
                                    title: "Basic Level",
                                    path: "/en/solution/smartfarm/rmfarm#rmfarm",
                                },
                                {
                                    title: "RMFARM Entry-level",
                                    path: "/en/solution/smartfarm/rmfarm#rmfarm",
                                },
                                {
                                    title: "FarmingON",
                                    path: "/en/solution/smartfarm/farmingon#farmingon",
                                },
                                {
                                    title: "FarmingON2",
                                    path: "/en/solution/smartfarm/farmingon#farmingon2",
                                },
                                // {
                                //     title: "Outdoor Smart Farm",
                                //     path: "/en/solution/smartfarm/ground",
                                // },
                                {
                                    title: "Smart Irrigation Control",
                                    path: "/en/solution/smartfarm/irrigation",
                                },
                            ],
                        },
                        {
                            title: "Farmire Vertical Farm",
                            path: "/en/solution/plant/led",
                            children: [
                                {
                                    title: "LED Lighting System",
                                    path: "/en/solution/plant/led",
                                },
                                {
                                    title: "Cultivation Management System",
                                    path: "/en/solution/plant/rearing",
                                },
                                {
                                    title: "Integrated Vertical Farm Management System",
                                    path: "/en/solution/plant/control",
                                },
                            ],
                        },
                        {
                            title: "AI Big Data",
                            path: "/en/solution/bigdata",
                        },
                    ],
                },
                {
                    title: "Community",
                    path: "/en/community/notice",
                    children: [
                        {
                            title: "Notice",
                            path: "/en/community/notice",
                        },
                        {
                            title: "Media",
                            path: "/en/community/magazine",
                        },
                        // {
                        //     title: "IR",
                        //     path: "/en/community/ir",
                        // },
                        {
                            title: "Inquiry",
                            path: "/en/community/inquire",
                        },
                        {
                            title: "Product Catalog",
                            path: "/en/community/catalog",
                        },
                    ],
                },
                // {
                //     title: "Farmire Mall",
                //     href: "http://shopire.kr",
                // },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>
